import { groupByScopeCategory, getScopeAccessType, getScopeCategory, type ScopeAccessType } from '../../../common/scopeCategories'
import { type PermissionDefinition } from '../../../store/role/role'

export interface ScopeItem {
  scope: string
  label: string
  category: string
  accessType: ScopeAccessType
}

export const buildScopeGroups = (scopes: string[], permissions: PermissionDefinition[] = []): Map<string, ScopeItem[]> => {
  const permissionMap = new Map(permissions.map((p) => [p.id, p]))
  const items = scopes.map((scopeId) => ({
    scope: scopeId,
    label: permissionMap.get(scopeId)?.description ?? scopeId,
    category: getScopeCategory(scopeId),
    accessType: getScopeAccessType(scopeId),
  }))

  return groupByScopeCategory(items, (item) => item.category)
}
